import React from 'react';
import { FocusRing } from 'react-aria';
import S from './Textbox.styles';
const Textbox = React.forwardRef(({ className, hasError = false, readOnly = false, ...otherProps }, ref) => {
    return (React.createElement(S.Container, { className: className },
        React.createElement(FocusRing, { focusRingClass: "focus-ring" },
            React.createElement(S.Input, { ref: ref, ...otherProps, "data-error": hasError, disabled: readOnly }))));
});
Textbox.displayName = 'Textbox';
export default Textbox;
